import { render, staticRenderFns } from "./DataSyncWarning.vue?vue&type=template&id=6bcd5cca"
import script from "./DataSyncWarning.vue?vue&type=script&lang=ts"
export * from "./DataSyncWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports